// extracted by mini-css-extract-plugin
export default {"list":"list--eFvs_","listItem":"listItem--W8WnI"};